import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['header'];

  initialize() {
    this.adjustHeaderOnScroll ();
    this.fadeInAndOutFlash();
    window.addEventListener('popstate', function(event) {
      location.reload();
    });

    // si la page est chargé suite à un retour arrière, on reload la page
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        location.reload();
      }
  });
  }

  adjustHeaderOnScroll () {
    const header = document.querySelector('header');
   
    if (header) {     
      window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      });
      window.dispatchEvent(new Event('scroll'));
    }
  };

  fadeInAndOutFlash() {
    const flash = document.querySelector('#user-layout-flash');

    if (flash) { 
      // Apparition
      requestAnimationFrame(() => {
        flash.classList.remove('opacity-0');
        flash.classList.add('opacity-100');
      });

      // Disparition après 5 secondes
      setTimeout(() => {
        flash.classList.remove('opacity-100');
        flash.classList.add('opacity-0', 'duration-1000');
      }, 3000);
    }
  }
}
